import { render, staticRenderFns } from "./verifyOtp.vue?vue&type=template&id=3b534e64&"
import script from "./verifyOtp.vue?vue&type=script&lang=js&"
export * from "./verifyOtp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports